import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { useEffect } from "react";
import { initializeApp, firebase} from "firebase/app";
import { getAuth } from "firebase/auth"
import { BrowserRouter } from "react-router-dom";
import { SpeedInsights } from "@vercel/speed-insights/react"





const firebaseConfig = {
  apiKey: "AIzaSyA_hcMHprdmf4j2nf5DxMEMcyTcYMhuBQ4",
  authDomain: "jeto-crm.firebaseapp.com",
  projectId: "jeto-crm",
  storageBucket: "jeto-crm.appspot.com",
  messagingSenderId: "1078479537939",
  appId: "1:1078479537939:web:6d22dc68cbe6ed45dabce6",
  measurementId: "G-BHBY6DB0GD"
};
const app = initializeApp(firebaseConfig);
export const auth=getAuth()

// const WelcomePage = () => {


// return(
ReactDOM.render(
  <React.StrictMode>
    {/* <BrowserRouter> */}
    <App />
    <SpeedInsights />
    {/* </BrowserRouter> */}
  </React.StrictMode>,
  document.getElementById('root')
)
// )
// }